import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "BachatRaja" },
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join(", ");
  return d || e?.message || "Something went wrong";
};

let trackToken = "";
export const setTrackToken = (t) => { trackToken = t || ""; };
const withT = (u) => (trackToken ? `${u}&t=${encodeURIComponent(trackToken)}` : u);
export const goUrl = (dealId, src = "site") => withT(`${API}/go/${dealId}?src=${src}`);
export const storeGoUrl = (slug) => withT(`${API}/go/store/${slug}?src=site`);
export const shareUrl = (dealId) => `${API}/s/${dealId}`;
export const couponGoUrl = (id) => withT(`${API}/go/coupon/${id}?src=site`);

export const inr = (n) =>
  n === null || n === undefined || n === "" ? "—" : `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
